module.exports = __webpack_public_path__ + "static/img/pose-enseigne-angers-adhesif-vitrine-9.3536793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pose-enseigne-angers-adhesif-vitrine-9.jpg
// module id = 6Elu
// module chunks = 1